/*eslint import/no-unresolved: [2, { ignore: ['^jsx:.+\\.svg$'] }]*/
import { useState } from 'react';
import { useTimeoutFn } from 'react-use';

// import { LoadingSpinner } from '../../lib/components/loading-spinner';
// import { yup } from '../../lib/utils';

export function Loading({ after = 0 }) {
  const [hide, setHide] = useState(after > 10);
  useTimeoutFn(() => setHide(false), after);
  return (
    <div className="text-white/50 data-[hide=true]:hidden" data-hide={hide}>
      ...
    </div>
  );
}
//<LoadingSpinner />

Loading.propTypes = {
  //after: yup.number().integer().min(1),
};
